import { getBusinessErrorCode, getErrorMessage } from '@/lib/error-utils';

export const SCREENPLAY_VERSION_NOT_READY_CODE = 'SCREENPLAY_VERSION_NOT_READY';

const SCREENPLAY_VERSION_NOT_READY_MESSAGE = '剧本分析数据更新中';

export function isScreenplayVersionNotReadyError(error: unknown): boolean {
  if (getBusinessErrorCode(error) === SCREENPLAY_VERSION_NOT_READY_CODE) {
    return true;
  }
  return getErrorMessage(error, '').includes(SCREENPLAY_VERSION_NOT_READY_MESSAGE);
}
